import { PAYMENTSLINKDETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  payments: [],
  paymentsLinkDetailsStatus: undefined,
  paymentsLinkDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENTSLINKDETAILS.FETCH:
      return {
        ...state,
        paymentsLinkDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case PAYMENTSLINKDETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        paymentsLinkDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case PAYMENTSLINKDETAILS.FAILED:
      return {
        ...state,
        paymentsLinkDetailsError: action.payload,
        paymentsLinkDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    case PAYMENTSLINKDETAILS.PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.payload,
      };
    default:
      return state;
  }
};
